import AppError from '@/common/state/AppError';
import { DriveItem } from '@/drive/entities/DriveItem/DriveItem';
import { DriveItemsResponse } from '@/drive/entities/DriveItemsResponse';

export function toDriveItemsErrorResponse<T extends DriveItem>(
  error: unknown,
  fallbackMessage: string,
): DriveItemsResponse<T> {
  const message = error instanceof AppError ? error.title : fallbackMessage;

  return new DriveItemsResponse<T>([{ error: message || fallbackMessage }]);
}
